import { MechanicalOrder } from '../model/mechanical-order';
import { MechanicalEstimateBuilder } from "./mechanical-estimate-builder";
export class MechanicalOrderBuilder {
    static buildMechanicalOrder(data) {
        const mechanicalOrder = new MechanicalOrder();
        mechanicalOrder.id = (data.id) ? +data.id : null;
        mechanicalOrder.id_via = (data.id_via) ? +data.id_via : null;
        mechanicalOrder.id_workshop = (data.id_workshop) ? +data.id_workshop : null;
        mechanicalOrder.id_reservation = (data.id_reservation) ? +data.id_reservation : null;
        mechanicalOrder.id_vehicle_identification = (data.id_vehicle_identification) ? +data.id_vehicle_identification : null;
        mechanicalOrder.id_vehicle = (data.id_vehicle) ? +data.id_vehicle : null;
        mechanicalOrder.id_mechanical_estimate = (data.id_mechanical_estimate) ? +data.id_mechanical_estimate : null;
        mechanicalOrder.status = data.status;
        mechanicalOrder.pvp = (data.pvp) ? +data.pvp : null;
        mechanicalOrder.vat = (data.vat) ? +data.vat : null;
        mechanicalOrder.base = (data.base) ? +data.base : null;
        mechanicalOrder.date_created = data.date_created;
        mechanicalOrder.date_reserved = data.date_reserved;
        mechanicalOrder.date_confirmed = data.date_confirmed;
        mechanicalOrder.date_in = data.date_in;
        mechanicalOrder.date_car_picked = data.date_car_picked;
        mechanicalOrder.date_car_picked_expected = data.date_car_picked_expected;
        mechanicalOrder.date_car_returned = data.date_car_returned;
        mechanicalOrder.date_car_returned_expected = data.date_car_returned_expected;
        mechanicalOrder.date_car_checked = data.date_car_checked;
        mechanicalOrder.date_out = data.date_out;
        mechanicalOrder.date_dimissed = data.date_dimissed;
        mechanicalOrder.dismiss_reason_code = data.dismiss_reason_code;
        mechanicalOrder.in_car_km = data.in_car_km;
        mechanicalOrder.invoice_required = data.invoice_required;
        mechanicalOrder.out_car_km = data.out_car_km;
        mechanicalOrder.returned_warning_internal_message = data.returned_warning_internal_message;
        mechanicalOrder.mechanical_works_data = (data.mechanical_works_data) ? MechanicalEstimateBuilder.buildMechanicalEstimate(data.mechanical_works_data) : null;
        mechanicalOrder.mechanical_works_data_source = data.mechanical_works_data_source;
        mechanicalOrder.date_mechanical_works = data.date_mechanical_works;
        mechanicalOrder.mechanical_estimate = (data.mechanical_estimate) ? MechanicalEstimateBuilder.buildMechanicalEstimate(data.mechanical_estimate) : null;
        return mechanicalOrder;
    }
}
//# sourceMappingURL=mechanical-order-builder.js.map